import type { ComputedRef, Ref } from 'vue'
import type { UseFinancingsParams } from './useFinancings'
import { useQuery } from '@tanstack/vue-query'
import { computed, unref } from 'vue'
import { queryKeys } from '~/queryClient'
import financingBff from '~/services-v2/financial-bff/financial-bff'

type MaybeRef<T> = T | Ref<T> | ComputedRef<T>

interface UseFinancingSearchOptions {
  enabled?: MaybeRef<boolean>
}

function createFinancingSearchQueryFn(params: UseFinancingsParams) {
  return async () => {
    const partnerId = params.partner_id === '' || params.partner_id === null || params.partner_id === undefined
      ? undefined
      : params.partner_id.toString()

    const res = await financingBff('query')({
      financings: [{
        input: {
          is_combo: params.is_combo,
          order_by: params.order_by,
          page: params.page,
          page_size: params.page_size,
          partner_id: partnerId,
          query: params.query,
          status: params.status,
          steps: params.steps,
        },
      }, {
        data: {
          id: true,
          customer_name: true,
          step: true,
          status: true,
          project_id: true,
          person_type: true,
          new_journey: true,
        },
      }],
    })

    return res.financings
  }
}

export default function useFinancingSearch(
  params: Ref<UseFinancingsParams>,
  options: UseFinancingSearchOptions = {},
) {
  const queryKey = computed(() => queryKeys.FINANCINGS.LIST(params.value))

  const queryFn = () => createFinancingSearchQueryFn(params.value)()

  const enabled = computed(() => options.enabled === undefined ? true : unref(options.enabled))

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 30,
  })
}

export type FinancingSearchResult = ReturnType<typeof useFinancingSearch>['data']['value']
export type FinancingSearchItem = NonNullable<FinancingSearchResult>['data'][number]
